import Verification from './verification-container';

export default Verification;
